const ToolPlugin = {
  install (Vue, options) {
    let tool = {
      wait: function (time) {
        return new Promise(resolve => {
          setTimeout(() => { resolve() }, time)
        })
      },
      getClosestNumberFromArray: function (targetNumber, targetArray) {
        let closestNumber = targetArray.reduce((prev, curr) => {
          return (Math.abs(+curr - +targetNumber) < Math.abs(+prev - +targetNumber) ? +curr : +prev)
        })
        return closestNumber
      },
      playTts: function (text) {
        if ('speechSynthesis' in window) {
          let msg = new SpeechSynthesisUtterance(text)
          let voiceName = 'Google US English'
          msg.voice = window['speechSynthesis'].getVoices().filter(voice => { return voice.name === voiceName })[0]
          window['speechSynthesis'].speak(msg)
        } else {
          console.warn('TTS is not supported')
        }
      },
      cancelTts: function (text) {
        if ('speechSynthesis' in window) {
          window['speechSynthesis'].cancel()
        } else {
          console.warn('TTS is not supported')
        }
      },
      copyTextToClipboard: function (text) {
        let textArea = document.createElement('textarea')
        textArea.style.position = 'fixed'
        textArea.style.top = 0
        textArea.style.left = 0
        textArea.style.width = '2em'
        textArea.style.height = '2em'
        textArea.style.padding = 0
        textArea.style.border = 'none'
        textArea.style.outline = 'none'
        textArea.style.boxShadow = 'none'
        textArea.style.background = 'transparent'
        textArea.style.opacity = 0
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          alert('"' + text + '" is successfully copied to your clipboard.')
        } catch (err) {
          alert('Oops, unable to copy text')
          console.warn('Oops, unable to copy text')
          console.warn(err)
        }
        document.body.removeChild(textArea)
      },
      setCookie: function (cname, cvalue, date) {
        let domain = this.getCookieDomainForCurrentDomain()
        if (!date) {
          let now = new Date()
          now.setFullYear(now.getFullYear() + 5)
          date = now.toUTCString()
        }
        document.cookie = encodeURIComponent(cname) + '=' + encodeURIComponent(cvalue) + ';expires=' + date + ';domain=' + domain + ';path=/'
      },
      getCookie: function (cname) {
        let name = encodeURIComponent(cname) + '='
        let cookie = document.cookie
        let ca = cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i]
          while (c.charAt(0) === ' ') {
            c = c.substring(1)
          }
          if (c.indexOf(name) === 0) {
            let cookieToReturn = decodeURIComponent(c.substring(name.length, c.length))
            if (cookieToReturn === 'undefined') return undefined
            else if (cookieToReturn === 'null') return null
            else if (cookieToReturn === 'NaN') return NaN
            else return cookieToReturn
          }
        }
        return ''
      },
      deleteCookie: function (cname) {
        this.setCookie(cname, 'meaning_less_string', 'Thu, 01 Jan 1970 00:00:01 GMT')
      },
      getCookieDomainForCurrentDomain: function () {
        let temp = window.location.hostname.split('.')
        if (temp.length > 1) {
          return '.' + temp[+temp.length - 2] + '.' + temp[+temp.length - 1]
        } else {
          return temp[0]
        }
      },
      encodeToBase64: function (str) {
        return window.btoa(str)
      },
      decodeFromBase64: function (base64Str) {
        return window.atob(base64Str)
      },
      encodeToBase64Url: function (str) {
        let base64Str = this.encodeToBase64(str)
        var base64Url = base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
        return base64Url
      },
      decodeFromBase64Url: function (base64Url) {
        if (base64Url.length % 4 === 2) base64Url = base64Url + '=='
        if (base64Url.length % 4 === 3) base64Url = base64Url + '='
        let base64Str = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        let str = this.decodeFromBase64(base64Str)
        return str
      },
      capitalizeFirstLetter: function (string) {
        string = string.toLowerCase()
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      redirectToUrl: function (url) {
        // similar behavior as an HTTP redirect
        window.location.replace(url)
      },
      goToUrl: function (url) {
        // similar behavior as clicking on a link
        window.location.href = url
      },
      openUrl: function (url) {
        // similar behavior as clicking on a link
        window.open(url)
      },
      openNewTab: function (url) {
        var win = window.open(url, '_blank')
        if (win) {
          // Browser has allowed it to be opened
          win.focus()
        } else {
          // Browser has blocked it
          alert('Please allow popups for this website')
        }
      },
      getTodayBeginTimestamp: function (timezoneOffset) {
        let now = Vue.time.newDate()
        let timestamp = now.getTime()
        if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000
        let localNow = new Date(timestamp)
        timestamp = Math.floor((new Date((new Date(localNow.setHours(0))).setMinutes(0))).setSeconds(0) / 1000) * 1000
        if (timezoneOffset !== undefined) timestamp -= (now.getTimezoneOffset() * 60 * 1000 + timezoneOffset * 60 * 1000)
        return timestamp
      },
      getNowTimestamp: function (timezoneOffset) {
        let now = Vue.time.newDate()
        let timestamp = now.getTime()
        if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000
        return timestamp
      },
      getLocalTimestamp: function (timestamp, timezoneOffset) {
        let now = Vue.time.newDate()
        if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000
        return timestamp
      },
      hasAllKeys: function (obj, keys) {
        let result = false
        if (obj instanceof Object && keys instanceof Array) {
          let undefinedKeys = []
          keys.map(key => {
            if (obj[key] === undefined) undefinedKeys.push(key)
          })
          if (undefinedKeys.length === 0) result = true
          else {
            console.log('utils.hasAllKeys failed')
            console.log(undefinedKeys)
          }
        } else {
          console.log('utils.hasAllKeys failed')
        }
        return result
      },
      getTimeDiffFromNow: function (timestamp) {
        let now = Vue.time.newDate()
        let diff = Math.round((now.getTime() - timestamp) / 1000)
        let text = null
        let textDetail = null
        if (diff < 60) {
          text = '1m'
          textDetail = diff + 's'
        } else if (diff < 60 * 60) {
          text = Math.round(diff / 60) + 'm'
          textDetail = text
        } else if (diff < 60 * 60 * 24) {
          text = Math.round(diff / 60 / 60) + 'h'
          textDetail = text
        } else {
          text = Math.round(diff / 60 / 60 / 24) + 'd'
          textDetail = text
        }
        return {
          text: text,
          textDetail: textDetail,
          diffInSec: diff
        }
      },
      getFriendlyTimeFromSec: function (seconds) {
        let text = null
        if (seconds < 60) {
          text = '1m'
        } else if (seconds < 60 * 60) {
          text = Math.round(seconds / 60) + 'm'
        } else if (seconds < 60 * 60 * 24) {
          text = Math.round(seconds / 60 / 60) + 'h'
        } else {
          text = Math.round(seconds / 60 / 60 / 24) + 'd'
        }
        return text
      },
      methodLogger (moduleName, logMessage) {
        let re = /at\s[a-zA-Z0-9.]+/g
        let aRegexResult = new Error().stack.match(re)
        let callerName = (aRegexResult[1] || aRegexResult[2]).replace('at ', '').replace('VueComponent.', '')
        let moduleNameCss = 'background:#000000 ; padding: 0 1px; border-radius: 0;  color: #fff'
        let callerNameCss = 'background:#35495e ; padding: 0 1px; border-radius: 0;  color: #fff'
        let logMessageCss = 'background:#41b883 ; padding: 0 1px; border-radius: 0;  color: #fff'
        if (moduleName && logMessage) {
          console.log('%c ' + moduleName + ' %c ' + callerName + ' %c ' + logMessage + ' ', moduleNameCss, callerNameCss, logMessageCss)
        } else if (moduleName) {
          console.log('%c ' + moduleName + ' %c ' + callerName + ' ', moduleNameCss, callerNameCss)
        } else if (logMessage) {
          console.log('%c ' + callerName + ' %c ' + logMessage + ' ', callerNameCss, logMessageCss)
        }
      },
      isValidEmailAddress (email) {
        let regexp = new RegExp('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
        regexp = new RegExp('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,3}$')
        if (regexp.test(email)) {
          return true
        } else {
          return false
        }
      },
      isValidMacAddress (macAddress) {
        let regexp = new RegExp('[0-9A-F]{12}')
        if (regexp.test(macAddress)) {
          return true
        } else {
          return false
        }
      },
      isValidPassword (password) {
        // (?=.*[a-z]) The string must contain at least 1 lowercase alphabetical character
        // (?=.*[A-Z]) The string must contain at least 1 uppercase alphabetical character
        // (?=.*[0-9]) The string must contain at least 1 numeric character
        // (?=.[!@#\$%\^&]) The string must contain at least one special character, but we are escaping reserved RegEx characters to avoid conflict
        // (?=.{8,}) The string must be eight characters or longer
        let strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')
        let mediumRegex = new RegExp('^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})')
        let regexp = strongRegex
        regexp = mediumRegex
        if (regexp.test(password)) {
          return true
        } else {
          return false
        }
      },
      convertCamelToNormal (str) {
        return str
        // insert a space before all caps
          .replace(/([A-Z])/g, ' $1')
        // uppercase the first character
          .replace(/^./, function (str) { return str.toUpperCase() })
      },
      randomString (length) {
        let charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~'
        let result = ''
        while (length > 0) {
          let bytes = new Uint8Array(16)
          let random = window.crypto.getRandomValues(bytes)
          random.forEach((c) => {
            if (length === 0) {
              return
            }
            if (c < charset.length) {
              result += charset[c]
              length--
            }
          })
        }
        return result
      },
      isUserAgentMobile () {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        if (isMobile) return true
        else return false
      }
    }
    Vue.prototype.$tool = tool
    Vue.tool = tool
  }
}

export default ToolPlugin



// WEBPACK FOOTER //
// ./src/plugins/tool.js